import { memo, useLayoutEffect, useRef, useState } from 'react';

import { Button, ButtonProps } from '@components/button';

import { useFormContext } from './form-provider';

type FormSubmitButtonProps = Omit<ButtonProps, 'id'> & {
  action?: string;
  shouldDisableWhenNotDirty?: boolean;
};

export const FormSubmit = memo<FormSubmitButtonProps>(
  ({ action = 'submit', shouldDisableWhenNotDirty, isDisabled: externalIsDisabled, ...rest }) => {
    const {
      store: { useIsSubmitDisabled },
      handleSubmitClick,
    } = useFormContext();
    const internalIsDisabled = useIsSubmitDisabled(action, shouldDisableWhenNotDirty);
    const isDisabled = externalIsDisabled || internalIsDisabled;
    const [isInsideForm, setIsInsideForm] = useState(true);
    const buttonRef = useRef<HTMLButtonElement>(null);

    useLayoutEffect(() => {
      const formsOnCurrentPage = Array.from(document.querySelectorAll('form'));

      if (buttonRef.current) {
        const isInsideForm = formsOnCurrentPage.some((f) => f.contains(buttonRef.current));
        setIsInsideForm(isInsideForm);
      }
    }, []);

    const isExtraButton = action !== 'submit';
    const shouldHandleSubmit = isExtraButton || !isInsideForm;

    return (
      <Button
        ref={buttonRef}
        isDisabled={isDisabled}
        {...rest}
        type={isExtraButton ? 'button' : 'submit'}
        onClick={(e) => {
          rest.onClick?.(e);

          if (shouldHandleSubmit) {
            handleSubmitClick(action);
          }
        }}
      />
    );
  }
);

FormSubmit.displayName = 'Form.Submit';
